import React, { Component } from "react";

import { css } from "styled-components";
import PropTypes from "prop-types";

import breakpoints from "../../../styles/breakpoints";
import OffCanvasTray from "../OffCanvasTray";
import MyCellarReviewBody from "../MyCellarReviewBody";
import AnimatingTrayContainer from "../../atoms/AnimatingTrayContainer";
import { isSmallDevice } from "../../../helpers/tools";

export const imageSectionStyle = css`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;

export const bodySectionStyle = css`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;

export const bodySectionContentStyle = css`
  ${breakpoints.smUp} {
    padding: 40px !important;
    &:last-child {
      padding-bottom: 120px !important;
    }
  }
`;

class MyCellarReviewTray extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: false,
    };
  }

  /**
   * this function sets the state of hide to true,
   * so, the hiding action can start animating,
   * then, close the tray after 200ms.
   * */
  handleCloseTray = () => {
    this.setState({ hide: true });
    const { onCloseButtonClick, isOpened, isFromSavedList } = this.props;
    const isSmall = isSmallDevice();
    if (isSmall && isFromSavedList) {
      onCloseButtonClick();
      return;
    }
    setTimeout(() => isOpened && onCloseButtonClick(), 200);
  };

  render() {
    const {
      selectedWine,
      onSuccessfulUpdate,
      toggleRefetchingAfterWineReview,
      setRandomVariableRewards,
      onUpdateProductRatingSuccess,
    } = this.props;
    const { hide } = this.state;
    return (
      <OffCanvasTray
        setOverflowHidden={false}
        isOffcanvasOpened
        outSideClickHandler={() => this.handleCloseTray()}
      >
        <AnimatingTrayContainer isOpened hide={hide}>
          <MyCellarReviewBody
            wine={selectedWine}
            imageSectionStyle={imageSectionStyle}
            bodySectionStyle={bodySectionStyle}
            bodySectionContentStyle={bodySectionContentStyle}
            showCloseButtonInImageSection
            onCloseButtonClick={() => this.handleCloseTray()}
            /* Default success close goes through the same slide-out as the
               back arrow — the raw prop would unmount the tray with no
               animation. */
            onSuccessfulUpdate={onSuccessfulUpdate || (() => this.handleCloseTray())}
            toggleRefetchingAfterWineReview={toggleRefetchingAfterWineReview}
            setRandomVariableRewards={setRandomVariableRewards}
            onUpdateProductRatingSuccess={onUpdateProductRatingSuccess}
          />
        </AnimatingTrayContainer>
      </OffCanvasTray>
    );
  }
}

MyCellarReviewTray.propTypes = {
  selectedWine: PropTypes.shape({}).isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
  setRandomVariableRewards: PropTypes.func.isRequired,
  onSuccessfulUpdate: PropTypes.func,
  onUpdateProductRatingSuccess: PropTypes.func,
  isOpened: PropTypes.bool.isRequired,
  toggleRefetchingAfterWineReview: PropTypes.func,
  isFromSavedList: PropTypes.bool,
};

MyCellarReviewTray.defaultProps = {
  onSuccessfulUpdate: null,
  toggleRefetchingAfterWineReview: null,
  isFromSavedList: false,
};

export default MyCellarReviewTray;
